// This is being used for the toggle button in the shared secrets index page
import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["content", "buttonText", "icon", "iconDown", "iconUp", "preview"]
  static values = { expanded: Boolean }

  connect() {
    this.updateView()
  }

  toggle() {
    this.expandedValue = !this.expandedValue
    this.updateView()
  }

  updateView() {
    const button = this.element.querySelector('[data-action="click->toggle#toggle"]')
    const showText = button?.dataset.toggleShowText || "Toon ontvangers"
    const hideText = button?.dataset.toggleHideText || "Verberg ontvangers"
    
    if (this.expandedValue) {
      this.contentTarget.classList.remove("hidden")
      if (this.hasPreviewTarget) {
        this.previewTarget.classList.add("hidden")
      }
      if (this.hasButtonTextTarget) {
        this.buttonTextTarget.textContent = hideText
      }
      
      // Handle icon swapping if both iconDown and iconUp targets exist
      if (this.hasIconDownTarget && this.hasIconUpTarget) {
        this.iconDownTarget.classList.add("hidden")
        this.iconUpTarget.classList.remove("hidden")
      } else if (this.hasIconTarget) {
        // Fallback to rotation for old implementation
        this.iconTarget.classList.add("rotate-180")
      }
    } else {
      this.contentTarget.classList.add("hidden")
      if (this.hasPreviewTarget) {
        this.previewTarget.classList.remove("hidden")
      }
      if (this.hasButtonTextTarget) {
        this.buttonTextTarget.textContent = showText
      }
      
      // Handle icon swapping if both iconDown and iconUp targets exist
      if (this.hasIconDownTarget && this.hasIconUpTarget) {
        this.iconDownTarget.classList.remove("hidden")
        this.iconUpTarget.classList.add("hidden")
      } else if (this.hasIconTarget) {
        // Fallback to rotation for old implementation
        this.iconTarget.classList.remove("rotate-180")
      }
    }
  }
}